import { onBeforeUnmount, onMounted, ref } from 'vue'

// Cmd-K (Mac) / Ctrl-K (others) opens the command palette. Listener is
// installed at the window level so the shortcut works no matter where
// focus sits — sidebar input, drawer textarea, header button, anywhere.
// We stop short of intercepting the keystroke when the user is mid-IME
// composition (event.isComposing) so accented input on a French/Korean
// keyboard isn't hijacked.
export function useCommandPalette() {
  const open = ref(false)

  function onKey(event: KeyboardEvent): void {
    if (event.isComposing) return
    if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
      event.preventDefault()
      open.value = !open.value
    }
  }

  onMounted(() => window.addEventListener('keydown', onKey))
  onBeforeUnmount(() => window.removeEventListener('keydown', onKey))

  return { open }
}
